import React from 'react';
import { EcoClub7Class2026 } from '../views';


const AccountGeneralPage = () => {
  return <EcoClub7Class2026/>;
};

export default AccountGeneralPage;